export const isDevStore = (name) => name.indexOf('bc-dev-v2') === 0;